import React from "react";

type ContainerSize = "sm" | "md" | "lg" | "full";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: ContainerSize;
  className?: string;
  children: React.ReactNode;
}

const MAX_WIDTH: Record<ContainerSize, string> = {
  sm: "max-w-3xl",
  md: "max-w-5xl",
  lg: "max-w-6xl",
  full: "max-w-full",
};

export function Container({
  size = "lg",
  className = "",
  children,
  ...rest
}: ContainerProps): React.ReactElement {
  return (
    <div
      className={`mx-auto w-full px-4 sm:px-6 lg:px-8 ${MAX_WIDTH[size]} ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Container;
